// src/modules/app-views/_apps/appsindico/unitProfiles/pages/Document/tabs/RecordTab.jsx
// *******************************************************************************
// UNIT PROFILES RECORD TAB
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const UnitProfilesRecordTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="unitProfileRecord" isFetching={loading} data={data} />

      {/* UNIT PROFILE DATA CARD */}
      <Card title={<div className="text-muted">{translateX('unit_profile_data')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={12}>
            <SimpleInput name="name" label="name" required />
          </Col>

          <Col xs={24} sm={12}>
            <SimpleTextArea name="description" label="description" rows={2} />
          </Col>
        </Row>

        <Row gutter={ROW_GUTTER}>
          <Col xs={24} sm={6}>
            <SimpleNumber name="area" label="area_m2" />
          </Col>

          <Col xs={24} sm={6}>
            <SimpleNumber name="rooms" label="rooms" />
          </Col>

          <Col xs={24} sm={6}>
            <SimpleNumber name="bathrooms" label="bathrooms" />
          </Col>

          <Col xs={24} sm={6}>
            <SimpleNumber name="suites" label="suites" />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default UnitProfilesRecordTab;
